import React, { isValidElement } from 'react';

import { Button, Text } from '@rover/kibble/core';
import { TextCommonProps } from '@rover/kibble/core/Text/Text.common';

type Props = TextCommonProps & {
  onClick?: (e?: React.MouseEvent<HTMLButtonElement>) => void;
  children?: React.ReactNode;
  'aria-describedby'?: string;
  'aria-label'?: string;
};

const FlatButton = ({
  children,
  onClick,
  'aria-describedby': ariaDescribedby,
  'aria-label': ariaLabel,
  ...other
}: Props): JSX.Element => {
  const handlePress = ({ webEvent }: { webEvent?: React.MouseEvent<HTMLElement> }): void => {
    if (onClick) {
      onClick(webEvent as React.MouseEvent<HTMLButtonElement>);
    }
  };

  return (
    <Button
      variant="flat"
      onPress={handlePress}
      size="small"
      sx={{
        background: 'none !important',
        p: '0x',
      }}
      alignSelf="inherit"
      aria-describedby={ariaDescribedby}
      aria-label={ariaLabel}
    >
      {isValidElement(children) ? (
        children
      ) : (
        <Text textDecoration="underline" sx={{ fontWeight: '600' }} {...other}>
          {children}
        </Text>
      )}
    </Button>
  );
};
export default FlatButton;
